import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["restrictProjectAccess","projectAccessControl"];
  connect() {
  }
  
  restrictProjectAccess(event) {
      if (this.restrictProjectAccessTarget.checked) {
        this.projectAccessControlTarget.style.display = "block";
      }
      else {
        this.projectAccessControlTarget.style.display = "none";
      }
  }
  disconnect() {}
}
